import mixpanel from 'mixpanel-browser';
import { getEnvVariable } from '@/utils/get-env-variable';

class MixpanelService {
  private isInitialized: boolean = false;

  initialize(): void {
    if (this.isInitialized) {
      return;
    }

    // Use environment variable, fallback to production key if not set
    const mixpanelToken = getEnvVariable('VITE_MIXPANEL_TOKEN', '36bc8102bd15fc0a7471651e632a1c1d');

    if (!mixpanelToken) {
      console.warn('Mixpanel: VITE_MIXPANEL_TOKEN not configured');
      return;
    }

    try {
      mixpanel.init(mixpanelToken, {
        debug: getEnvVariable('VITE_ENV') !== 'production',
        track_pageview: true,
        persistence: 'localStorage',
      });
      this.isInitialized = true;
      console.log('Mixpanel initialized successfully');
    } catch (error) {
      console.error('Failed to initialize Mixpanel:', error);
    }
  }

  track(eventName: string, properties?: Record<string, unknown>): void {
    if (!this.isInitialized) {
      console.warn('Mixpanel: Not initialized. Call initialize() first.');
      return;
    }

    try {
      mixpanel.track(eventName, properties);
    } catch (error) {
      console.error('Failed to track event in Mixpanel:', error);
    }
  }

  identify(userId: string): void {
    if (!this.isInitialized) {
      console.warn('Mixpanel: Not initialized. Call initialize() first.');
      return;
    }

    try {
      mixpanel.identify(userId);
    } catch (error) {
      console.error('Failed to identify user in Mixpanel:', error);
    }
  }

  setUserProperties(properties: Record<string, unknown>): void {
    if (!this.isInitialized) {
      console.warn('Mixpanel: Not initialized. Call initialize() first.');
      return;
    }

    try {
      mixpanel.people.set(properties);
    } catch (error) {
      console.error('Failed to set user properties in Mixpanel:', error);
    }
  }

  reset(): void {
    if (!this.isInitialized) {
      return;
    }

    try {
      mixpanel.reset();
    } catch (error) {
      console.error('Failed to reset Mixpanel:', error);
    }
  }

  isReady(): boolean {
    return this.isInitialized;
  }
}

export const mixpanelService = new MixpanelService();
